import chunk from 'lodash/chunk'

import { Chunk, DragAndDropStatusProps } from '../_types'

export function chunkItems<ItemType extends DragAndDropStatusProps>(
  itemsPerChunk: number,
  items: ItemType[],
): Chunk<ItemType>[] {
  const slicedItemsIntoChunks: ItemType[][] = chunk(items, itemsPerChunk)

  return slicedItemsIntoChunks.map((chunkItems, index) => ({
    id: String(index),
    items: chunkItems,
  }))
}
